import { m } from 'framer-motion';

import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import Stack from '@mui/material/Stack';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import { useTheme } from '@mui/material/styles';
import Container from '@mui/material/Container';
import WbSunnyIcon from '@mui/icons-material/WbSunny';
import DarkModeIcon from '@mui/icons-material/DarkMode';
import Badge, { badgeClasses } from '@mui/material/Badge';

import { useOffSetTop } from 'src/hooks/use-off-set-top';
import { useResponsive } from 'src/hooks/use-responsive';

import { colors } from 'src/utils/colors';
import { useScreenWidth } from 'src/utils/useScreenWidth';

import { bgBlur } from 'src/theme/css';

import Logo from 'src/components/logo';
import Iconify from 'src/components/iconify';
import { varBounce } from 'src/components/animate';
import CButton from 'src/components/cbutton/Cbutton';
import { useSettingsContext } from 'src/components/settings';

import NavMobile from './nav/mobile';
import NavDesktop from './nav/desktop';
import { HEADER } from '../config-layout';
import HeaderShadow from '../common/header-shadow';

// ----------------------------------------------------------------------

export default function Header() {
  const theme = useTheme();
  const { isMobile } = useScreenWidth();

  const mdUp = useResponsive('up', 'md');

  const offsetTop = useOffSetTop(HEADER.H_DESKTOP);
  const settings = useSettingsContext();
  const changeTheme = (currentTheme) => {
    settings.onUpdate('themeMode', currentTheme);
  };

  const navConfig = [
    {
      title: 'Home',
      icon: <Iconify icon="solar:home-2-bold-duotone" />,
      path: '/',
    },
    // {
    //   title: 'About',
    //   icon: <Iconify icon="solar:home-2-bold-duotone" />,
    //   path: '/#about',
    // },
    {
      title: 'Brands',
      icon: <Iconify icon="solar:home-2-bold-duotone" />,
      path: '/brand/baby-bib',
      children: [
        {
          subheader: 'Ziyaq kids',
          items: [
            { title: 'Baby bib', path: '/brand/baby-bib', logo: '/assets/images/banner/bib-banner.png' },
            { title: 'Baby knee pad', path: '/brand/baby-knee-pad', logo: '/assets/images/banner/knee-pad-banner.png' },
          ],
        },
      ]
    },
    {
      title: 'Testimonials',
      icon: <Iconify icon="solar:home-2-bold-duotone" />,
      path: '/#testimonials',
    },
    {
      title: 'Contact us',
      icon: <Iconify icon="solar:home-2-bold-duotone" />,
      path: '/#contact',
    },
  ];


  return (
    <AppBar sx={{ backgroundColor: settings?.themeMode === 'dark' ? "#1b243c" : '#fff' }}>
      <Toolbar
        disableGutters
        sx={{
          height: {
            xs: HEADER.H_MOBILE,
            md: HEADER.H_DESKTOP,
          },
          transition: theme.transitions.create(['height'], {
            easing: theme.transitions.easing.easeInOut,
            duration: theme.transitions.duration.shorter,
          }),
          ...(offsetTop && {
            ...bgBlur({
              color: theme.palette.background.default,
            }),
            height: {
              md: HEADER.H_DESKTOP_OFFSET,
            },
          }),
        }}
      >
        <Container sx={{ height: 1, display: 'flex', alignItems: 'center' }}>
          <Badge
            sx={{
              [`& .${badgeClasses.badge}`]: {
                top: 8,
                right: -16,
              },
            }}
            badgeContent={

              <Link
                href="/"
                target="_blank"
                rel="noopener"
                underline="none"
                sx={{ ml: 1, color: "transparent" }}
              >
                Ziyaq
              </Link>
            }
          >
            <Logo />
          </Badge>

          <Box sx={{ flexGrow: 1 }} />


          {mdUp && <NavDesktop data={navConfig} />}

          {!isMobile && <Stack flexDirection="row" alignItems="center" mx={4}>
            {settings?.themeMode === 'dark' ? (
              <m.div
                variants={varBounce().inDown}
                transition={{
                  mass: 400,
                  stiffness: 400,
                }}
              >
                <WbSunnyIcon sx={{ cursor: 'pointer' }} onClick={() => changeTheme('light')} />
              </m.div>
            ) : (
              <DarkModeIcon sx={{ cursor: 'pointer', color: colors.primary }} onClick={() => changeTheme('dark')} />
            )}
          </Stack>}



          <Stack alignItems="center" direction={{ xs: 'row', md: 'row-reverse' }}>
            <a href='tel:+919400139148' target='_blank' rel="noreferrer">
              <CButton>
                Request a Callback
              </CButton>
            </a>
          </Stack>

          {!mdUp && <NavMobile data={navConfig} />}

        </Container>
      </Toolbar>

      {offsetTop && <HeaderShadow />}
    </AppBar>
  );
}
